/* eslint-disable import/no-unused-modules */
import React, { ComponentType, createContext, forwardRef, useContext } from "react";
import { App } from "../components/App";
import { TComponent } from "../types/utils";

type TAppContextValue = ReturnType<App["getContext"]>;

export const AppContext = createContext<TAppContextValue>({} as any);

type TAppContextProviderProps = {
    context: TAppContextValue;
    children: React.ReactNode;
};

export const AppContextProvider: TComponent<TAppContextProviderProps> = ({ context, children }) => {
    return <AppContext.Provider value={context ?? {}}>{children}</AppContext.Provider>;
};

// Hook for functional components
export const useAppContext = (): TAppContextValue => {
    const ctx = useContext(AppContext);
    if (!ctx) {
        throw new Error("useAppContext must be used within AppContextProvider");
    }
    return ctx;
};

// HOC for class components
export const withAppContext = <Props extends Record<string, any>>(
    WrappedComponent: ComponentType<Props & TAppContextProp>
) =>
    forwardRef((props: any, ref) => (
        <WrappedComponent
            ref={ref}
            {...{
                appContext: useContext(AppContext),
                ...props,
            }}
        />
    ));
export type TAppContextProp = { appContext: TAppContextValue };
